import router from "./router";

const getComponent = (page) => {
  return router[page] || router[`P${page}`] || router['pageNull'];
}

export default getComponent;

export {router};


// WEBPACK FOOTER //
// src/routes/exportPDF/getComponent.js